import { useSelector } from 'react-redux';
import { RemoteRecord } from 'b2b-apps/shop/common/redux/RemoteRecord';
import { getSubscription } from 'b2b-apps/shop/newsletter/redux/selectors';
import { NewsletterType } from 'b2b-apps/shop/newsletter/redux/types';

type UseNewsletterSubscriptionDataReturnType = RemoteRecord<NewsletterType>;

function useNewsletterSubscriptionData(): UseNewsletterSubscriptionDataReturnType {
  return useSelector(getSubscription);
}

export type { UseNewsletterSubscriptionDataReturnType };
export { useNewsletterSubscriptionData };
